import { render, staticRenderFns } from "./VTRomLoader.vue?vue&type=template&id=340baed7&"
import script from "./VTRomLoader.vue?vue&type=script&lang=js&"
export * from "./VTRomLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports